import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/reports/balanceAdjustments/filter'; // Importing Filter component
import Table from 'views/reports/balanceAdjustments/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the balance adjustments view.
 * @extends JetView
 */
export default class balanceAdjustmentsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100', '1000'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                            $$('datatable').scrollTo(100, 0); // Scroll to top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index
                            var last = first + size - 1; // Last item index
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reportee de Ajustes de Saldos'),
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reportee de Ajustes de Saldos'),
                                    ignore: {
                                        detailTittle: true,
                                        Action: true,
                                    },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Reportee de Ajustes de Saldos'),
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de Ajustes de Saldos'),
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            Action: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        {
                            view: 'label',
                            label: _('Reporte de Ajustes de Saldos'), // Report title
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon', // Search icon
                                    icon: 'wxi-search',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                Filter, // Filter component
                Table, // Table component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Form view
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section with components
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screens
                var childs = $$('toolbar').getChildViews();
                $$('toolbar').removeView(childs[2]); // Remove close button
                $$('pagerA').define('group', 1); // Group pager items
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screens
                $$('button-search').hide(); // Hide search button
            }
            $.fn.scrollBottom = function () {
                // Custom jQuery function to get scroll bottom
                return $$(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
